<template>
  <div class="kyc-status-badge" :class="statusClass">
    <f7-icon :f7="statusIcon" size="14" />
    <span>{{ displayLabel }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import i18n from '../../js/i18n.js'
import { storeToRefs } from 'pinia'
import { useKycStore } from '../../js/pinia-stores/kyc.js'

const { t } = i18n.global

const props = defineProps({
  status: { type: [String, Object], default: null },
})

const kycStore = useKycStore()
const { kycStatus } = storeToRefs(kycStore)

const rawStatus = computed(() => {
  if (!props.status && !kycStatus.value) return 'PENDING'
  const s = props.status || kycStatus.value
  if (typeof s === 'string') return s
  return s?.status || 'PENDING'
})

const statusLabel = computed(() => {
  const s = rawStatus.value
  if (!s) return t('kyc.statusPending')
  return t('kyc.status' + s.charAt(0) + s.slice(1).toLowerCase())
})

const statusClass = computed(() => 'kyc-badge--' + rawStatus.value.toLowerCase())
const statusIcon = computed(() => {
  switch (rawStatus.value) {
    case 'VERIFIED': return 'checkmark_circle_fill'
    case 'REJECTED': return 'xmark_circle_fill'
    case 'FAILED': return 'exclamationmark_triangle_fill'
    case 'IN_PROGRESS': return 'clock_fill'
    default: return 'clock'
  }
})

const displayLabel = statusLabel
</script>

<style scoped>
.kyc-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}
.kyc-badge--verified {
  background: color-mix(in srgb, #1a6b42 12%, transparent);
  color: #1a6b42;
}
.kyc-badge--pending {
  background: color-mix(in srgb, #f5a623 12%, transparent);
  color: #8a6000;
}
.kyc-badge--in_progress {
  background: color-mix(in srgb, #007aff 12%, transparent);
  color: #007aff;
}
.kyc-badge--rejected, .kyc-badge--failed {
  background: color-mix(in srgb, #c0440a 12%, transparent);
  color: #c0440a;
}
</style>